"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PocCloudTabs from "@/components/pageTabs/pocCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import ComparisonComponent from "./components/comparison";
import FeaturesComponent from "./components/features";
import UseCasesComp from "./components/useCases";

const EmulateSimulateRealPage = () => {
  return (
    <PageLayout showContactForm>
      <Hero />
      <PocCloudTabs />
      <Intro />
      <ComparisonComponent />
      <FeaturesComponent />
      <UseCasesComp />
      <Faqs />
    </PageLayout>
  );
};

export default EmulateSimulateRealPage;
